/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';

import { ImageManager } from '../common/ImageManager';
import Avatar from '../Avatar';
import styles from './index.styl';

const imageManagerStyles = {
  position: 'absolute',
  top: '0',
  right: '0',
};

const Logo = ({
  image,
  offset,
  name,
  size,
  formatMessage,
  isModerator,
  onImageRemove,
  onImageCrop,
}) => {
  const url = get(image, 'thumbMin');

  return (
    <div
      styleName={classNames('logo', {
        'logo--offset': offset,
      })}
    >
      <Avatar
        children={name}
        src={url}
        bordered
        position="center"
        size={size}
        noTransparent
      />
      <ImageManager
        removeTitle={formatMessage({ id: 'community.logo.removeTitle' })}
        cropTitle={formatMessage({ id: 'community.logo.cropTitle' })}
        onImageRemove={onImageRemove}
        onImageCrop={onImageCrop}
        hidden={!isModerator}
        style={imageManagerStyles}
        aspectRatio={1}
        rounded
      />
    </div>
  );
};

Logo.propTypes = {
  onImageRemove: PropTypes.func.isRequired,
  onImageCrop: PropTypes.func.isRequired,
  isModerator: PropTypes.bool.isRequired,
  formatMessage: PropTypes.func.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string,
  }),
  offset: PropTypes.bool,
  name: PropTypes.string,
  size: PropTypes.number,
};

Logo.defaultProps = {
  size: 40,
};

export default CSSModules(Logo, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Community/Logo.jsx